import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { lazy } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { updateSessionStatus } from './@core/actions';
import './App.css';
import { Loadable } from './components/loadable';

const ResponsiveAppBar = Loadable(lazy(() => import('./components/navbar/ResponsiveAppBar')));
const PrivateBurnDonePage = Loadable(lazy(() => import('./pages/PrivateBurnDonePage')));
const PrivateHomePage = Loadable(lazy(() => import('./pages/PrivateHomePage')));
const PrivateLinkPage = Loadable(lazy(() => import('./pages/PrivateLinkPage')));
const PrivateBurnPage = Loadable(lazy(() => import('./pages/PrivateBurnPage')));
const SecretHomePage = Loadable(lazy(() => import('./pages/SecretHomePage')));
const SecretShowPage = Loadable(lazy(() => import('./pages/SecretShowPage')));
const SupportPage = Loadable(lazy(() => import('./pages/SupportPage')));

function App() {
  const csrfData = useSelector((state) => state.csrf);
  const dispatch = useDispatch();
  return (

    <div className="App">
      <ResponsiveAppBar />
      <Container maxWidth="lg">
        <BrowserRouter>

          <Routes>
            <Route path="/" element={<PrivateHomePage />} />
            <Route path="/link" element={<PrivateLinkPage />} />
            <Route path="/burn" element={<PrivateBurnPage />} />
            <Route path="/burned" element={<PrivateBurnDonePage />} />
            <Route path="/secret/:key" element={<SecretHomePage />} />
            <Route
              path="*"
              element={<Navigate to="/" replace />}
            />
          </Routes>

        </BrowserRouter>
      </Container>
      <ToastContainer></ToastContainer>
      {csrfData.loading &&
        <div className="loading"></div>
      }

      <Dialog
        open={csrfData.sessionExpired}
        keepMounted
        onClose={() => { }}
        aria-describedby="alert-dialog-session-expired"
      >
        <Box sx={{ mt: 2 }}>
          <DialogContent>
            <DialogContentText id="alert-dialog-session-expired">
              Your session has expired. Please Click "OKAY" to reload your session
            </DialogContentText>
          </DialogContent>
        </Box>
        <DialogActions sx={{ alignItems: 'center', justifyContent: 'center', mb: 2 }}>
          <Button variant="contained" onClick={() => {
            dispatch(updateSessionStatus(false));
            window.location.reload();
          }}>Okay</Button>
        </DialogActions>
      </Dialog>
      <SupportPage/>
    </div>
  );
}

export default App;
